module.exports = __webpack_public_path__ + "static/media/ncb shot 04.29808658.webp";